import AdminUserDetailPage from "@/features/system-settings/pages/AdminUserDetail";

const AdminUserDetail = () => {
  return <AdminUserDetailPage />;
};
export default AdminUserDetail;
